import development from './development';
import production from './production';
import both from './both';

const list = {
  development,
  production,
  both,
};

const Config = {
  ...both,
  ...list[process.env.REACT_APP_STAGE || 'development'],
};

export default Config;
